import { gql, useQuery } from "@apollo/client";
import { XIcon } from "@heroicons/react/solid";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";
import { useSearchParam } from "react-use";
import { useIntercom } from "react-use-intercom";
import Button from "../../components/Button";
import Logo from "../../components/Logo";
import Modal from "../../components/Modal";
import { ROUTE_HOME, ROUTE_SETTINGS } from "../../routes";
import { logout } from "../../store/modules/user/actions";
import Home from "../Home";
import Settings from "../Settings";
import Footer from "./components/Footer";
import Header from "./components/Header";

const App = () => {
  const { update } = useIntercom();
  const waitlist = useSearchParam("waitlist");
  const { data, loading } = useQuery(gql`
    {
      self {
        uuid
        email
        fullName
      }
    }
  `);

  useEffect(() => {
    if (!loading && data) {
      update({
        userId: data.self.uuid,
        email: data.self.email,
        name: data.self.fullName,
      });
    }
  }, [loading, data, update]);

  return (
    <div className="min-h-screen bg-gray-100">
      {waitlist && <WaitListModal />}
      <Header />
      <main className="-mt-24 pb-8">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
          <Switch>
            <Route path={ROUTE_HOME}>
              <Home />
            </Route>
            {/* <Route path={ROUTE_ACCOUNTS}>
              <Accounts />
            </Route>
            <Route path={ROUTE_TRANSACTIONS}>
              <Transactions />
            </Route>
            */}
            <Route path={ROUTE_SETTINGS}>
              <Settings />
            </Route>
            <Redirect to={ROUTE_HOME} />
          </Switch>
        </div>
      </main>
      <Footer />
    </div>
  );
};

const WaitListModal = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <Modal
      isOpen
      onRequestClose={() => {
        history.push(ROUTE_HOME);
      }}
    >
      <div className="p-8 relative" style={{ width: 600 }}>
        <button
          className="absolute top-4 right-4 text-gray-600 w-6 h-6"
          onClick={() => {
            history.push(ROUTE_HOME);
          }}
        >
          <XIcon />
        </button>
        <div className="absolute top-4 left-4">
          <Logo size={20} type="plain" />
        </div>
        <div className="prose prose-lg text-center">
          <h3> Thank You for Joining the Wait List!</h3>
          <p>
            Here at Due we are working hard to bring you the next revolutionary
            retirement plans. Please bear with us as we are working hard to
            create the best experience for our users. We will reach out when we
            launch!
          </p>
        </div>
        <div className="flex justify-center mt-6">
          <Button onClick={() => dispatch(logout())}>Log Out</Button>
          <Button className="ml-4" onClick={() => history.push(ROUTE_HOME)}>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default App;
